// extracted by mini-css-extract-plugin
module.exports = {"FinishedQuiz":"FinishQuiz_FinishedQuiz__1QeF1","success":"FinishQuiz_success__2x-PE","error":"FinishQuiz_error__sXxIz"};